import { useContext } from 'react';
import { DevModeContext } from './context';

const useDevMode = () => {
    const ctx = useContext(DevModeContext);

    if (!ctx) {
        throw new Error('useDevMode must be used inside DevModeProvider');
    }

    return ctx;
};

export default useDevMode;
